
































































import { Component } from 'vue-property-decorator';
import { storeService, paymentService } from '@/shared';
import { Base } from "@/components/common/base";
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';

@Component({
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue')
    },
})
class DailyPaymentReport extends Base {
    public selectedDate: string | null = this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
    public todayDate: string = _dateTime.currentDate(new Date());
    public menu: boolean = false;
    public selectedStores: number[] = [];
    public storeList: any[] = [];
    public reportData: any[] = [];
    public paymentresponseData: any[] = [];
    public isStoreLoading: boolean = false;
    public isReportLoading: boolean = false;
    public ispaymentresponseLoading: boolean = false;
    public paymentresponseheaders: any[] = [
        { text: "Record Number", value: "recordKey", sortable: true },
        { text: "Payment Identifier", value: "paymentIdentifier", sortable: true },
        {
            text: "Errors", value: "errorMessage", sortable: true, fieldType: "template",
            template: (item) => {
                return `<div style="display:flex; flex-direction:column; gap:4px;">${item.errorMessage
                    .map(err => `<div class="red--text text--darken-2">${err}</div>`)
                    .join("")}</div>`;
            }
        },
        {
            text: "Failed At", value: "time", sortable: true, fieldType: "template",
            template: (item) => {
                return `<div>${this.$moment(item.time).local().format("DD MMM YYYY, hh:mm A")}</div>`;
            }
        },
    ];
    public headers: any[] = [
        { text: "Store Name", value: "storeName", sortable: true },
        { text: "Total", value: "total", sortable: true },
        { text: "RO's", value: "subTotal", sortable: true },
        { text: "AL Success", value: "success", sortable: false },
        {
            text: "Other Failure", value: "otherFailure", sortable: false,
            fieldType: 'template',
            template: (item) => {
                if (!item.otherFailure || item.otherFailure === 0) {
                    return `<span>${item.otherFailure}</span>`;
                }

                return `
        <div style="display:flex; gap:8px;">
          <span>${item.otherFailure}</span>
          <button class="failure-btn" data-id="${item.storeId}" data-type="other">
            <v-icon medium :color="'success'" >fas fa-eye</v-icon>
          </button>
        </div>
      `;
            }
        },
        {
            text: "AL Failure", value: "failed", sortable: false,
            fieldType: 'template',
            template: (item) => {
                if (!item.failed || item.failed === 0) {
                    return `<span>${item.failed}</span>`;
                }

                return `
        <div style="display:flex; gap:8px;">
          <span>${item.failed}</span>
          <button class="failure-btn" data-id="${item.storeId}" data-type="al">
            <v-icon medium :color="'success'" >fas fa-eye</v-icon>
          </button>
        </div>
      `;
            }
        },
        { text: "AL Duplicate", value: "duplicate", sortable: true },
        { text: "Offline", value: "notFound", sortable: true },
        { text: "Type (Web)", value: "web", sortable: true },
        { text: "Type (TriPos)", value: "triPos", sortable: true },
        { text: "Provider", value: "provider", sortable: true }
    ];

    public failureDialogOptions: any = { model: false };

    public selectedFailureItem: any = null;

    public openFailureDialog(item: any) {
        this.selectedFailureItem = item;
        this.failureDialogOptions.model = true;
    }
    public async mounted() {
        this.$root.$emit('sidebar.layout.vue', 'dailyPaymentReport');
        await this.getStores();
        var currentStore = this.storeList.find(x => x.id == this.userSession.storeId);
        this.selectedStores.push(currentStore.id);
        await this.getReport();

        document.addEventListener('click', this.handleFailureClick);

    }

    private previousSelectedStores: number[] = [];
    public selectedStoreChanged() {

        const allIds = this.storeList
            .filter(s => s.id !== 0)
            .map(s => s.id);

        const hasSelectAll = this.selectedStores.includes(0);
        const hadSelectAll = this.previousSelectedStores.includes(0);

        // Select All clicked
        if (hasSelectAll && !hadSelectAll) {
            this.selectedStores = [0, ...allIds];
        }

        // Select All unchecked
        else if (!hasSelectAll && hadSelectAll) {
            this.selectedStores = [];
        }

        // If Select All present but a store unchecked
        else if (hasSelectAll && this.selectedStores.length < allIds.length + 1) {
            this.selectedStores = this.selectedStores.filter(x => x !== 0);
        }

        // If all stores manually selected
        else if (!hasSelectAll && allIds.every(id => this.selectedStores.includes(id))) {
            this.selectedStores = [0, ...allIds];
        }

        // Save current state
        this.previousSelectedStores = [...this.selectedStores];
    }

    public beforeDestroy() {
        document.removeEventListener('click', this.handleFailureClick);
    }

    public handleFailureClick(e: any) {
        try {
            this.ispaymentresponseLoading = true;
            const btn = e.target.closest('.failure-btn');
            if (!btn) return;

            const storeId = btn.getAttribute('data-id');
            const type = btn.getAttribute('data-type');
            const item = this.reportData.find(x => x.storeId == storeId);

            if (item) {
                this.openFailureDialog(item);

                if (type === 'other') {
                    this.paymentresponseData = item.otherPaymentFailedResponses  || [];
                }
                else {
                    this.paymentresponseData = item.paymentFailedResponses || [];
                }
            }
        }
        finally {
            this.ispaymentresponseLoading = false;
        }
    }
    public async getStores(): Promise<void> {
        try {
            this.isStoreLoading = true;
            const response = await storeService.getStoresList();
            this.storeList = response.results || [];

            if (this.storeList.length > 0) {
                this.storeList.unshift({
                    id: 0,
                    dealershipName: "Select All"
                });
            }

        } catch (error) {
            console.error("Error fetching stores:", error);
        } finally {
            this.isStoreLoading = false;
        }
    }

    public async getReport(): Promise<void> {
        if (!this.selectedDate) {
            this.showAlert(false, this.$t('Date is required'));
            return;
        }

        if (!this.selectedStores || this.selectedStores.length === 0) {
            this.showAlert(false, this.$t('Store selection is required'));
            return;
        }
        try {
            if (this.selectedStores.includes(0)) {
                this.selectedStores = this.selectedStores.filter(id => id !== 0);
            }
            this.isReportLoading = true;
            const response = await paymentService.getDailyPaymentReport(
                this.userSession.tenantId,
                this.userSession.enterpriseId,
                this.selectedStores,
                this.selectedDate
            );

            this.reportData = response;
        } catch (error) {
            console.error("Error fetching report:", error);
        } finally {
            this.isReportLoading = false;
        }
    }
}
export default DailyPaymentReport;
